/**
 * Reconnaître une erreur d'accès Meta Ads, pour ne pas la répéter dans chaque bloc.
 *
 * Quand la connexion Facebook expire, l'écran affiche déjà un bandeau en tête — « Authentification
 * Meta Ads expirée », avec le bouton qui la renouvelle. Chaque table posait par-dessus un
 * « ❌ auth_expired » : le code technique du serveur, montré tel quel, sous un titre de section qui
 * n'avait alors rien à présenter.
 *
 * Deux défauts en un. Le premier est que ce n'est pas une phrase : `auth_expired` ne dit rien à qui
 * ne connaît pas l'API. Le second est plus gênant — un bloc vide sous son titre se lit comme une
 * section en panne, alors que la seule chose à faire est déjà proposée plus haut, une fois.
 *
 * Les sections concernées disparaissent donc, et le bandeau reste seul à porter la nouvelle.
 */

/**
 * Les codes que le serveur rend quand l'accès n'est plus valable.
 *
 * `permission_denied` accompagne `auth_expired` partout où App.js les teste : un jeton révoqué et
 * un compte auquel on n'a plus accès demandent la même chose à l'utilisateur — reconnecter.
 */
const CODES_ACCES = ['auth_expired', 'permission_denied'];

/**
 * @param {string|null} erreur le message d'erreur remonté par la table
 * @returns {boolean} vrai s'il s'agit d'un défaut d'accès, que le bandeau de tête annonce déjà
 */
export const estErreurAcces = (erreur) => {
  if (!erreur) return false;
  const texte = String(erreur);
  return CODES_ACCES.some(code => texte.includes(code));
};
